export const SET_PAGE = 'SET_PAGE';
export const PAGE_MAIN = 'main';
export const PAGE_EXPOSITION = 'exposition';

export const setPage = (page) => ({
	type: SET_PAGE,
	page,
});

export const goToMain = () => setPage(PAGE_MAIN);
export const goToExposition = () => setPage(PAGE_EXPOSITION);
